// utils/inviteService.js
export const sendInviteEmails = async (invitees, dryRun = false) => {
  try {
    const responses = [];
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME || "Fantasy League Central";
    for (const invitee of invitees) {
      const response = await fetch(`${API_BASE_URL}/api/email/invite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // include authentication credentials
        body: JSON.stringify({
          to: invitee.to,
          name: invitee.name,
          league_name: invitee.league_name,
          action_url: invitee.action_url, // or generate here if needed
          product_name: PRODUCT_NAME,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Failed to send invite.");
      }

      responses.push(data);
    }

    return responses;
  } catch (err) {
    console.error("Error sending invites:", err);
    throw err;
  }
};
